import {
  Box,
  Button,
  CardActions,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
  useTheme,
} from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import * as React from 'react';
import { useState } from 'react';
import { Context, IContext } from '../../../Context';
import { Device, DeviceType, Light, statusEnum } from '../../../Interface';
import { DeviceIcon } from '../../Devices/DeviceIcon';
import { DeviceModal } from '../../NewDevices/Modals/DeviceModal';

interface LightsCounterProps {
  delete: Function;
}

function filterDevices(dev: Device) {
  return (
    dev.type === DeviceType.light ||
    dev.type === DeviceType.dimLight ||
    dev.type === DeviceType.rgbLight
  );
}
function filterLights(dev: Device) {
  const light: Light = dev as Light;
  return light.light.status === statusEnum.ON;
}

export const LightsCounter: React.FunctionComponent<LightsCounterProps> = (
  props
) => {
  const context: IContext = React.useContext(Context);
  const lights = [
    ...context.allDevices.filter(filterDevices).filter(filterLights),
  ];
  const theme = useTheme();
  const [showPopup, setPopup] = useState(false);
  const [showDevice, setDevice] = useState<number | undefined>(undefined);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const findDevice = (id: number) => {
    const dev = context.allDevices.find((dev) => dev.id === id);
    return (dev as Light) || (({} as unknown) as Light);
  };

  const printPath = (path: number[]) => {
    let names: string[] = [];
    path.forEach((el) => {
      context.allLevels.forEach((found) => {
        if (el === found.id)
          names.push(context.custom[context.language].levels.name[found.id]);
      });
    });
    names.shift();
    return <span className='widget-device-path'>{names.join(' \u2192 ')}</span>;
  };

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => props.delete()}>
          {context.i18n[context.language].widgets.general.delete}
        </MenuItem>
      </Menu>
      <CardContent
        style={{
          flexShrink: 1,
          minHeight: 0,
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          flexGrow: 1,
          paddingBottom: 0,
        }}
      >
        <Box
          position='absolute'
          top={theme.spacing(1)}
          right={theme.spacing(1)}
        >
          <IconButton onClick={handleClick} size='small'>
            <MoreVert />
          </IconButton>
        </Box>
        <Typography color='textSecondary' gutterBottom style={{ fontSize: 14 }}>
          {context.i18n[context.language].widgets.lightsCounter.title}
        </Typography>
        <Typography>
          {context.i18n[context.language].widgets.general.thereAre}
          <Typography
            component='span'
            color='primary'
            style={{ margin: '10px', fontWeight: 'bold' }}
          >
            {lights.length}
          </Typography>
          {context.i18n[context.language].widgets.lightsCounter.lightsOn}
        </Typography>
      </CardContent>
      <CardActions style={{ justifyContent: 'flex-end' }}>
        {lights.length > 0 && (
          <Button onClick={() => setPopup(true)} color='primary'>
            {context.i18n[context.language].widgets.general.show}
          </Button>
        )}
      </CardActions>
      <Dialog
        open={showPopup}
        onClose={() => {
          setPopup(false);
          setDevice(undefined);
        }}
        scroll='paper'
        maxWidth='sm'
        fullWidth
      >
        <DialogTitle>
          {context.i18n[context.language].widgets.lightsCounter.lightsList}
        </DialogTitle>
        <DialogContent>
          <List>
            {lights.map((light) => {
              return (
                <React.Fragment key={'lights-' + light.id}>
                  <ListItem
                    onClick={() => {
                      setPopup(false);
                      setDevice(light.id);
                    }}
                    button
                  >
                    <ListItemIcon>
                      <DeviceIcon
                        default='fas fa-lightbulb'
                        status={1}
                        icons={light.icons}
                        style={{
                          fontSize: '15pt',
                          marginLeft: '15px',
                        }}
                        className={'fa-2x'}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        context.custom[context.language].devices.name[light.id]
                      }
                      secondary={printPath(light.path)}
                    />
                  </ListItem>
                  <Divider variant='inset' />
                </React.Fragment>
              );
            })}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPopup(false)}>
            {context.i18n[context.language].alarms.dialog.close}
          </Button>
        </DialogActions>
      </Dialog>
      {showDevice && (
        <DeviceModal
          device={findDevice(showDevice)}
          open={true}
          onClose={() => {
            setPopup(true);
            setDevice(undefined);
          }}
        />
      )}
    </>
  );
};
